import { createRouter, createWebHistory} from 'vue-router'
import tool from '@/common/tool'
// import share from '@/common/share'
import axios from '@/common/axios'
import urls from '@/common/urls'
import store from '@/store'
import config from '../common/config'
const commonRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'page404',
    component: () => import(/* webpackChunkName "page404" */ '@/components/help/page404.vue')
  },
  {
    path: '/project404',
    name: 'project404',
    component: () => import(/* webpackChunkName "project404" */ '@/components/help/project404.vue')
  },
];
const ignoreRoutes = [
  {
    path: '/jump',
    name: 'jump',
    component: () => import(/* webpackChunkName "jump" */ '@/components/common/jump.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName "home" */ '@/components/menu/indexPage/subcategoryIndex.vue')
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import(/* webpackChunkName "chat" */ '@/components/menu/indexPage/dzSubcategoryIndex.vue')
  },
  {
    path: '/',
    name: '/',
    component: () => import(/* webpackChunkName "/" */ '@/components/index.vue')
  },
];
const routes = [].concat(commonRoutes, ignoreRoutes);


export const initRouter = async () => {
  const baseUrl = `${location.origin}/category`;
  if(location.href.startsWith(baseUrl)){
    const router = createRouter({
      history: createWebHistory("/category/"),
      routes
    });
    return router
  }
  //企业定制
  const dzBaseUrl = `${location.origin}/chat`;
  const dzBaseUrl2 = `${location.origin}/jump`;
  if (location.href.startsWith(dzBaseUrl) || location.href.startsWith(dzBaseUrl2)){
    const router = createRouter({
      history: createWebHistory("/"),
      routes
    });
    return router
  }
  let suffix = location.pathname;
  if (suffix != '/' && suffix != '/index' && suffix != '/jump') {
    let currLocation = tool.isLocal() ? `${config.chatHost}${location.pathname}` : location.href;
    const res = await axios.get(tool.getURL(urls.index.get_category_info, { url: currLocation }));
    tool.setStorage(`${res.data.base_info.suffix}-areaInfo`, res.data);
    tool.setStorage("suffix", res.data.base_info.suffix);
    suffix = res.data.base_info.suffix;
  }
  let path = null
  if (!tool.isLocal()) {
    path = suffix;
  }
  else path = '/'
  console.log('path', path)
  const router = createRouter({
    history: createWebHistory(`${path}`),
    routes
  });
  return router
}
const router = await initRouter();
const ignorePages = ignoreRoutes.map(item => item.name) // 不需要验证的页面
const jumpPath = ["bind", "help", "page404", "login","project404"]
const noProjectPage = [];//需要登录，但不需要project_id的页面
router.beforeEach((to, from, next) => {
  if(to.query.company_id){
    tool.setStorage("company_id", to.query.company_id,sessionStorage);
  }
  if (ignorePages.includes(to.name) || jumpPath.includes(to.name) || !config.authentication) {
    next();
    return;
  }
  next()
  return;
})

//进行登录操作
const login = (to, from, next) => {
  let data = tool.getLocalCookie("userInfo")
  axios.post(urls.user.login, data).then((res) => {
    let storeUser = {
      username: res.data.name,
      ...res.data
    }
    tool.getLocalCookie("userInfo", data)
    // tool.setStorage("AuthToken", res.token)
    store.dispatch("setItem", { userInfo: storeUser })
    tool.setStorage("project_name",res.project_info.project_name);
    tool.setStorage("project_info",res.project_info);
    next()
  }).catch(() => {
    // next()
    next({ name: "login", path: "/login", query: { ...to.query } })
  })
}
export default router;